@if (visible()) {
  <div
    class="cmdk-scrim"
    data-testid="cmdk-scrim"
    role="presentation"
    (mousedown)="onBackdropPointerDown($event)">

    <div
      #panel
      class="cmdk-panel glass"
      role="dialog"
      aria-modal="true"
      data-testid="cmdk-panel"
      [attr.aria-label]="dialogLabel()"
      [imFocusTrap]="visible()"
      imFocusTrapAutoFocus="none">

      <im-cmdk-input-row
        [listboxId]="listboxId"
        [activeDescendantId]="search.activeDescendantId()"
        [topItem]="search.topItem()"
        [aiEnabled]="aiEnabled()"
        (voiceToggled)="toggleVoice('mic')" />

      <im-cmdk-scope-chips />

      @if (!coachMarkSeen()) {
        <im-cmdk-coach-mark />
      }

      <div class="cmdk-body">
        <im-cmdk-results-pane
          [listboxId]="listboxId"
          [listLabel]="listLabel()"
          [modifierHeld]="modifierHeld()"
          (activated)="activate($event, 'click')"
          (scopeChosen)="focusInput()" />

        <im-cmdk-preview-pane
          (activated)="activate($event, 'click')"
          (callPerson)="callPerson($event)"
          (continueInChat)="continueInChat()"
          (closeAnswer)="applyEscape()"
          (viewSpace)="viewSpaceFromAsk($event)" />
      </div>

      <im-cmdk-footer
        [resultCount]="search.resultCount()"
        [modifierHeld]="modifierHeld()"
        [listening]="voice.listening()"
        [aiEnabled]="aiEnabled()"
        [hasAnswer]="ask.hasAnswer()" />
    </div>
  </div>
}
